import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { ErrorMessage } from "formik";

const ImageUpload = ({ label, name, setFieldValue, multiple = false, initialFiles = [], onRemove }) => {
  const [previews, setPreviews] = useState([]);

  // Initialize previews
  useEffect(() => {
    if (initialFiles && initialFiles.length > 0) {
      const normalized = initialFiles.map((img) => {
        if (typeof img === "string") return { file: null, url: img, keepOld: true };
        if (img && img.image) return { file: null, url: img.image, keepOld: true };
        if (img instanceof File) return { file: img, url: URL.createObjectURL(img), keepOld: false };
        return null;
      }).filter(Boolean);
      setPreviews(normalized);
    } else {
      setPreviews([]);
    }
  }, [initialFiles]);

  // Handle new files
  const handleFilesChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newPreviews = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      keepOld: false,
    }));

    const updatedPreviews = multiple ? [...previews, ...newPreviews] : newPreviews;

    setPreviews(updatedPreviews);

    // Update Formik
    setFieldValue(
      name,
      multiple
        ? updatedPreviews.map((p) => (p.keepOld ? p.url : p.file))
        : updatedPreviews[0].keepOld
        ? updatedPreviews[0].url
        : updatedPreviews[0].file
    );
  };

  // Remove image
  const handleRemove = (index) => {
    const removed = previews[index];
    const updatedPreviews = [...previews];
    updatedPreviews.splice(index, 1);
    setPreviews(updatedPreviews);

    // Inform parent about removed old image
    if (removed.keepOld && onRemove) onRemove(removed);

    setFieldValue(
      name,
      multiple
        ? updatedPreviews.map((p) => (p.keepOld ? p.url : p.file))
        : updatedPreviews[0]?.keepOld
        ? updatedPreviews[0].url
        : updatedPreviews[0]?.file || ""
    );
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type="file"
        multiple={multiple}
        onChange={handleFilesChange}
      />
      <div className="mt-2 d-flex flex-wrap gap-2">
        {previews.map((img, idx) => (
          <div key={idx} style={{ position: "relative" }}>
            <img
              src={img.url}
              alt={`preview-${idx}`}
              style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 4 }}
            />
            <button
              type="button"
              onClick={() => handleRemove(idx)}
              style={{
                position: "absolute",
                top: -5,
                right: -5,
                background: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: 20,
                height: 20,
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <ErrorMessage name={name} component="div" className="text-danger small" />
    </Form.Group>
  );
};

export default ImageUpload;
